import _ from 'lodash';
import { call, put } from 'redux-saga/effects';
import api from 'services';
import * as cargoOrderActions from 'actions/cargoes/orders';
import * as actionTypes from 'constants/ActionTypes';
import { orderNew as mockOrder } from 'mocks/cargo/orderNew';
import moment from 'moment';

function* fillCargoType(clarified) {
    if (clarified.cargo[0].cargoType) {
        const responseCargoTypes = yield call(api.getCargoTypes);

        responseCargoTypes.data.push({
            _id: '59970a4513d689b67b8bf20d',
            name: 'Other',
        });

        const foundedType = responseCargoTypes.data.find(cargoType => cargoType._id === clarified.cargo[0].cargoType);

        if (foundedType) {
            clarified.cargo[0].cargoTypeName = foundedType.name;
        }
    }
}

function* fillPorts(clarified) {
    if (clarified.loadingPort) {
        const { data } = yield call(api.getPort, { id: clarified.loadingPort });
        clarified.loadingPortName = data.name;
    }

    if (clarified.unloadingPort) {
        const { data } = yield call(api.getPort, { id: clarified.unloadingPort });
        clarified.unloadingPortName = data.name;
    }
}

function portsFlat(ports, destination) {
    ports = _.cloneDeep(ports);
    return ports.forEach((item) => {
        if (item.oneOf.length > 1) {
            item.oneOf.forEach((prt) => {
                destination.push({
                    port: prt,
                    sign: prt.andOr,
                });
            });
        } else {
            destination.push({
                port: item.oneOf[0],
                sign: 'and',
            });
        }
    });
}

// eslint-disable-next-line require-yield
function* createOrders(clarified) {
    const newClarified = _.cloneDeep(clarified);
    const loadingPorts = [];
    const unloadingPorts = [];

    const loadingPortsNew = [
        {
            oneOf: [],
        },
    ];
    const unloadingPortsNew = [
        {
            oneOf: [],
        },
    ]; 

    const loadingPortsMap = [];
    const unloadingPortsMap = [];

    newClarified.cargo = newClarified.cargo.map(cargo => _.merge({}, mockOrder.cargo[0], cargo));

    if (newClarified.loadingPorts) {
        const cancellingDate = moment(newClarified.cancellingDate).utc().startOf('day').toDate();
        const readinessDate = moment(newClarified.readinessDate).utc().startOf('day').toDate();
        const currentDate = moment().utc().startOf('day').toDate();

        const loadingPortsOr = newClarified.loadingPorts && newClarified.loadingPorts.ports ? 
            Object.entries(newClarified.loadingPorts.ports) : [];
        const unloadingPortsOr = newClarified.unloadingPorts && newClarified.unloadingPorts.ports ? 
            Object.entries(newClarified.unloadingPorts.ports) : [];

        const loadingPortsAnd = newClarified.loadingPorts && newClarified.loadingPorts.multiPorts ? 
            Object.entries(newClarified.loadingPorts.multiPorts) : [];
        const unloadingPortsAnd = newClarified.unloadingPorts && newClarified.unloadingPorts.multiPorts ? 
            Object.entries(newClarified.unloadingPorts.multiPorts) : [];
        
        // first loading ports (or) 
        loadingPortsOr.forEach((loadingPortOr, loadingPortOrIndex) => {
            if (loadingPortOr[1] && loadingPortOr[1].port) {
                const { multiPierses, pierses } = newClarified.loadingPorts;
                loadingPortsNew[0].oneOf.push({
                    port: loadingPortOr[1].pId,
                    portName: loadingPortOr[1].port,
                    details: multiPierses ? multiPierses[loadingPortOrIndex] || '' : pierses[loadingPortOrIndex] || '',
                    cancellingDate: cancellingDate < currentDate ? currentDate : cancellingDate,
                    readinessDate: readinessDate < currentDate ? currentDate : readinessDate,
                    cancellingDateOld: cancellingDate < currentDate ? cancellingDate : '', // The field helps show message that date too old
                    readinessDateOld: readinessDate < currentDate ? readinessDate : '', // The field helps show message that date too old
                    andOr: loadingPortOrIndex === 0 ? 'and' : 'or',
                    additionalLayCanDetails: undefined,
                    layCanType: 'layCan',
                });
            }
        });

        loadingPortsAnd.forEach((loadingPortAnd, loadingPortAndIndex) => {
            if (loadingPortAnd[1] && loadingPortAnd[1].port) {
                const { multiPierses, pierses } = newClarified.loadingPorts;
                loadingPortsNew.push({
                    oneOf: [
                        {
                            port: loadingPortAnd[1].pId,
                            portName: loadingPortAnd[1].port,
                            details: multiPierses ? multiPierses[loadingPortAndIndex] || '' : pierses[loadingPortAndIndex] || '',
                            cancellingDate: cancellingDate < currentDate ? currentDate : cancellingDate,
                            readinessDate: readinessDate < currentDate ? currentDate : readinessDate,
                            cancellingDateOld: cancellingDate < currentDate ? cancellingDate : '', // The field helps show message that date too old
                            readinessDateOld: readinessDate < currentDate ? readinessDate : '', // The field helps show message that date too old
                            andOr: 'and',
                            additionalLayCanDetails: undefined,
                            layCanType: 'layCan',
                        },
                    ],
                });
            }
        });

        // first unloading port
        unloadingPortsOr.forEach((unloadingPortOr, unloadingPortOrIndex) => {
            if (unloadingPortOr[1] && unloadingPortOr[1].port) {
                const { multiPierses, pierses } = newClarified.unloadingPorts;
                unloadingPortsNew[0].oneOf.push({
                    port: unloadingPortOr[1].pId,
                    portName: unloadingPortOr[1].port,
                    details: multiPierses && multiPierses[unloadingPortOrIndex] ? 
                        multiPierses[unloadingPortOrIndex] || '' : pierses[unloadingPortOrIndex] || '',
                    cancellingDate: cancellingDate < currentDate ? currentDate : cancellingDate,
                    readinessDate: readinessDate < currentDate ? currentDate : readinessDate,
                    cancellingDateOld: cancellingDate < currentDate ? cancellingDate : '', // The field helps show message that date too old
                    readinessDateOld: readinessDate < currentDate ? readinessDate : '', // The field helps show message that date too old
                    andOr: unloadingPortOrIndex === 0 ? 'and' : 'or',
                });
            }
        });

        unloadingPortsAnd.forEach((unloadingPortAnd, unloadingPortAndIndex) => {
            if (unloadingPortAnd[1] && unloadingPortAnd[1].port) {
                const { multiPierses, pierses } = newClarified.unloadingPorts;
                unloadingPortsNew.push({
                    oneOf: [
                        {
                            port: unloadingPortAnd[1].pId,
                            portName: unloadingPortAnd[1].port,
                            details: multiPierses && multiPierses[unloadingPortAndIndex] ? 
                                multiPierses[unloadingPortAndIndex] || '' : pierses[unloadingPortAndIndex] || '',
                            cancellingDate: cancellingDate < currentDate ? currentDate : cancellingDate,
                            readinessDate: readinessDate < currentDate ? currentDate : readinessDate,
                            cancellingDateOld: cancellingDate < currentDate ? cancellingDate : '', // The field helps show message that date too old
                            readinessDateOld: readinessDate < currentDate ? readinessDate : '', // The field helps show message that date too old
                            andOr: 'and',
                        },
                    ],
                });
            }
        });

        loadingPorts.push({
            namePort: newClarified.loadingPortName,
            idPort: newClarified.loadingPort,
            cancellingDate: cancellingDate < currentDate ? currentDate : cancellingDate,
            readinessDate: readinessDate < currentDate ? currentDate : readinessDate,
            loadingPortDetails: '',
            cancellingDateOld: cancellingDate < currentDate ? cancellingDate : '', // The field helps show message that date too old
            readinessDateOld: readinessDate < currentDate ? readinessDate : '', // The field helps show message that date too old
            additionalLayCanDetails: undefined,
            layCanType: 'layCan',
        });

        unloadingPorts.push({
            namePort: newClarified.unloadingPortName,
            idPort: newClarified.unloadingPort,
            unloadingPortDetails: '',
        });

        portsFlat(loadingPortsNew, loadingPortsMap);
        portsFlat(unloadingPortsNew, unloadingPortsMap);
    }

    return _.merge(
        {},
        mockOrder,
        newClarified,
        {
            loadingPorts,
            unloadingPorts,
            loadingPortsNew,
            unloadingPortsNew,
            loadingPortsMap,
            unloadingPortsMap,
        },
    );
}

/**
 * Fill data from server
 * */
function* fillAndCreateCargoOrders(clarified) {
    const newClarified = _.cloneDeep(clarified);

    yield fillCargoType(newClarified);
    // yield createCargoesWithRanges(newClarified);
    yield fillPorts(newClarified);
    return yield createOrders(newClarified);
}

// eslint-disable-next-line import/prefer-default-export
export function* createCargoOrders(response) {
    let cargoOrders = [];

    if (response.status === 200) {
        if (response.data.clarified) {
            const clarifiedOnlyCargo = response.data.clarified.filter(c => c.typeCategory.includes('request'));

            if (clarifiedOnlyCargo.length > 0) {
                for (let key = 0; key < clarifiedOnlyCargo.length; key++) {
                    try {
                        cargoOrders.push(yield call(fillAndCreateCargoOrders, clarifiedOnlyCargo[key]));
                    } catch (e) {
                        yield put({
                            type: actionTypes.ADD_NOTIFICATION,
                            notification: {
                                title: 'Error',
                                message: 'Something went wrong',
                                level: 'error',
                                _id: new Date().getMilliseconds(),
                                autoDismiss: 4,
                            },
                        });
    
                        console.error(e);
                    }
                }
    
                cargoOrders = _.flatten(cargoOrders);
    
                yield put({
                    type: actionTypes.ADD_NOTIFICATION,
                    notification: {
                        title: 'Created',
                        message: `The ${cargoOrders.length} cargo orders created`,
                        level: 'success',
                        _id: new Date().getMilliseconds(),
                        autoDismiss: 4,
                    },
                });
                yield put(cargoOrderActions.createCargoOrders(cargoOrders));
                return;
            }
        }

        yield put(cargoOrderActions.addCargoOrder());

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Warning',
                message: 'The cargo orders did\'t create',
                level: 'warning',
                _id: new Date().getMilliseconds(),
                autoDismiss: 4,
            },
        });
    } else {
        yield put(cargoOrderActions.addCargoOrder());

        yield put({
            type: actionTypes.ADD_NOTIFICATION,
            notification: {
                title: 'Warning',
                message: 'The cargo orders did\'t create',
                level: 'warning',
                _id: new Date().getMilliseconds(),
                autoDismiss: 4,
            },
        });
    }
}



// WEBPACK FOOTER //
// ./app/sagas/cargoes/ordersNew.js